<template>
  <v-dialog
    v-model="showDialog"
    width="400px"
    @closed="handleClosed"
    @open="handleOpen">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>Eidt Model</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="handleClosed"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules">
          <div class="form-item">
            <span>Make</span>
            <el-form-item
              ref="make_id"
              prop="make_id"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.make_id"
                disabled
                :list="carClassOption.make"></v-select>

            </el-form-item>
          </div>
          <div class="form-item">
            <span>Model</span>
            <el-form-item
              ref="model"
              prop="model"
              :rules="rules.input"
            >
              <v-input
                v-model="formData.model"
                keyNonChinese
                uppercase></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>EV</span>
            <el-form-item
              ref="grade_electric"
              prop="grade_electric"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.grade_electric"
                :list="carClassOption.ev"></v-select>

            </el-form-item>
          </div>
          <div class="form-item">
            <span>Windscreen</span>
            <el-form-item
              ref="grade_wind"
              prop="grade_wind"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.grade_wind"
                :list="carClassOption.windscreen"></v-select>

            </el-form-item>
          </div>
          <div class="form-item">
            <span>Status</span>
            <el-form-item
              ref="status"
              prop="status"
              :rules="rules.select"
            >
              <v-select
                v-model="formData.status"
                :list="makeStatusOptions"></v-select>

            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <v-button @click="handleClosed">Cancel</v-button>
        <v-button
          green
          @click="handlerSave">Save</v-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {addCarMake, getCarMakeList, updateCarModel, updateSingleCarMake} from '@api/privateCarList'
export default {
  name: 'edit-manage-model-dialog',
  mixins: [MixinOptions, MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    },
    form:{
      type:Object,
      default:()=>({})
    },
    classId:{
      type:Number,
      default:11
    }
  },
  data(){
    return{
      showDialog:false,
      formData:{
        status:'',
        grade_wind:'',
        grade_electric:'',
        model:'',
        make_id:'',
      }
    }
  },
  computed:{
    make(){
      let {make} = this.form||{}
      return make
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        if(val){
          Object.keys(this.formData).some((item)=>{
            if(item in this.form){
              this.formData[item] = this.form[item]
            }
          })
        }
        this.showDialog = val
      }
    }
  },
  methods:{
    handleOpen(){

    },
    handlerSave(){
      this.network().updateCarModel()
    },
    handleClosed(){
      this.showDialog =false
      this.$emit('input',this.showDialog)
    },
    network(){
      return {
        updateCarModel: async(params) =>{
          let list = [{...this.formData,id:this.form.id}]
          params = {
            list,
            class_id:this.classId
          }
          const {data} = await updateCarModel(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
          this.$emit('refresh')
          this.showDialog = false
          this.$emit('input',this.showDialog)
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding: 15px;
  color: #616266;

  h1 {
    font-size: 24px;
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -15px;
    padding: 0 15px 15px 15px;
    border-bottom: 1px solid #dddfe7;

    h1 {
      font-size: 24px;
    }
  }
  .dialog-body{
    margin-top: 25px;
    padding-bottom: 10px;
  }
  .dialog-content {
    padding-top: 15px;

    & > div {
      flex: 1;
    }

    .left {
      margin-top: -15px;
      padding-right: 15px;
      padding-top: 15px;
      border-right: 1px solid #dddfe7;
    }

    .right {
      padding-left: 15px;
    }

    .form-box {
      margin-bottom: 10px;

      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
  }
}
</style>
